import {
    AuthenticationDetails
} from 'amazon-cognito-identity-js';
import aws from '../../utils/aws';
import { toast } from 'react-toastify';
import config from '../../config/config';
import { get, includes } from 'lodash';
import { clearUserMessageSession } from '../Layout/layoutActions';

export const LOGIN_LOAD = 'LOGIN/LOGIN_LOAD';
export const LOGIN_FAILURE = 'LOGIN/LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN/LOGIN_SUCCESS';
export const READ_ME_LOGIN_SUCCESS = 'LOGIN/READ_ME_LOGIN_SUCCESS';
export const LOGOUT = 'LOGIN/LOGOUT';
export const RETURN_TO_LOGIN = 'LOGIN/RETURN_TO_LOGIN';
export const UPDATE_EMAIL = 'LOGIN/UPDATE_EMAIL';
export const VERIFICATION_CODE_RECEIVED = 'LOGIN/VERIFICATION_CODE_RECEIVED';
export const FORGOT_PASSWORD = 'LOGIN/FORGOT_PASSWORD';
export const VERIFICATION_LOAD = 'LOGIN/VERIFICATION_LOAD';
export const VERIFICATION_SEND_SUCCESS = 'LOGIN/VERIFICATION_SEND_SUCCESS';
export const VERIFICATION_SEND_FAILURE = 'LOGIN/VERIFICATION_SEND_FAILURE';
export const STORE_USER = 'LOGIN/STORE_USER';
export const GET_README_TOKEN_SUCCESS = 'LOGIN/GET_README_TOKEN_SUCCESS';
export const GET_README_TOKEN_FAILURE = 'LOGIN/GET_README_TOKEN_FAILURE';
export const GET_README_TOKEN_LOAD = 'LOGIN/GET_README_TOKEN_LOAD';

export function loginSuccess() {
    return { type: LOGIN_SUCCESS };
}

export function forgotPassword() {
    return { type: FORGOT_PASSWORD };
}

export function returnToLogin() {
    return { type: RETURN_TO_LOGIN };
}

export function updateEmail(text) {
    return {
        text,
        type: UPDATE_EMAIL
    };
}

export function verificationCodeReceived() {
    return { type: VERIFICATION_CODE_RECEIVED };
}

export function storeUser(user) {
    return {
        type: STORE_USER,
        user
    };
}

export function logout() {
    clearUserMessageSession();
    aws.cognitoSignOut();
    aws.clearCachedId();

    return { type: LOGOUT };
}

export function login(username, password, dispatch, history, isReadme) {

    const authenticationData = {
        Password: password,
        Username: username
    };

    const blackListedUsernames = get(config, 'blackListedUsernames');
    if (includes(blackListedUsernames, username)) {
        toast('This account does not have access to the Nexio Dashboard', { type: 'error' });
    } else {
        dispatch({ type: LOGIN_LOAD });

        const user = aws.createUser(username);

        dispatch(storeUser(user));

        const authenticationDetails = new AuthenticationDetails(authenticationData);
        const callbacks = {
            newPasswordRequired: () => history.push('/setFirstPassword'),
            onFailure: (error) => {
                let userError = error;

                if (error.code === 'UserNotFoundException') {
                    userError = {
                        message: 'Incorrect username or password.'
                    };
                } else if (error.code === 'PasswordResetRequiredException') {
                    userError = {
                        message: 'Your password expired after 90 days. Please select the Forgot Password link below to continue.'
                    };
                }

                dispatch({
                    error: userError,
                    type: LOGIN_FAILURE
                });
            },
            onSuccess: (result) => {
                const idToken = result.getIdToken().getJwtToken();
                aws.getAwsCredentials(idToken);
                if (isReadme) {
                    dispatch(getReadmetoken(username, password));
                }
                dispatch(loginSuccess());
            }
        };

        user.authenticateUser(authenticationDetails, callbacks);
    }

}

export function getReadmetoken(username, password) {

    return {
        failureActionTypeOrCreator: getReadmeTokenFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${config.userManagementApiUrl}/readmeToken`,
            body: {
                username,
                password
            }
        },
        loadActionTypeOrCreator: GET_README_TOKEN_LOAD,
        successActionTypeOrCreator: getReadmeTokenSuccessCreator
    };
}

export function getReadmeTokenSuccessCreator(data) {
    return {
        message: data.message,
        type: GET_README_TOKEN_SUCCESS
    };
}

export function getReadmeTokenFailureActionCreator(error) {
    return {
        error,
        type: GET_README_TOKEN_FAILURE
    };
}

export function sendVerificationCode(userName, dispatch) {
    dispatch({ type: VERIFICATION_LOAD });

    const user = aws.createUser(userName);

    user.forgotPassword({
        inputVerificationCode: null,
        onFailure: (error) => {
            dispatch(verificationFailure(error));
        },
        onSuccess: () => {
            dispatch(verificationSuccess());
        }
    });
}

export function verificationSuccess() {
    return { type: VERIFICATION_SEND_SUCCESS };
}

export function verificationFailure(error) {
    return {
        error,
        type: VERIFICATION_SEND_FAILURE
    };
}
